import { AppDispatch, AppState } from '@nxsys/store';
import { agencyAction } from '@nxsys/store/slices/agency/reducer/agencySlice';
import { GetListTimesheetsParams } from '@nxsys/store/slices/timesheets/type';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimesheetsListing from './TimesheetsListing';

enum TIMESHEET_TAB {
  ALL = 'ALL',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

const TimesheetsAgency = () => {
  const [activeTab, setActiveTab] = useState<TIMESHEET_TAB>(TIMESHEET_TAB.ALL);

  const { user } = useSelector((state: AppState) => state.appStore);

  const dispatch = useDispatch<AppDispatch>();

  const { loading, list, pagination, queryParams } = useSelector(
    (state: AppState) => state.agencyStore.agencyTimesheetList,
  );

  const getApproveStatusByTab = (tab: TIMESHEET_TAB) => {
    const tabObj = {
      [TIMESHEET_TAB.ALL]: undefined,
      [TIMESHEET_TAB.AWAITING_APPROVAL]: 'PENDING',
      [TIMESHEET_TAB.APPROVED]: 'APPROVED',
      [TIMESHEET_TAB.REJECTED]: 'CANCEL',
    };
    return tabObj[tab];
  };

  const getTimeSheetList = (params: GetListTimesheetsParams) => {
    const newParams = {
      ...params,
      approveStatus: getApproveStatusByTab(activeTab),
      taxYear: undefined,
    };
    if (!user?.agencyId) {
      return;
    }

    dispatch(
      agencyAction.getAgencyTimesheetListById({
        id: user?.agencyId?.id ?? '',
        params: newParams,
      }),
    );
  };

  return (
    <TimesheetsListing
      timesheetsData={{
        list,
        pagination,
        queryParams,
      }}
      loading={loading}
      getTimeSheetList={getTimeSheetList}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    />
  );
};

export default React.memo(TimesheetsAgency);
